import { timeQuery } from 'helpers/Utils';
var SettingsInvoice = /** @class */ (function () {
    function SettingsInvoice(props) {
        Object.assign(this, props);
        this.updated = new Date(props.updated);
        this.image = timeQuery(props.image, this.updated);
    }
    return SettingsInvoice;
}());
export { SettingsInvoice };



//////////////////
// WEBPACK FOOTER
// ./src/modules/SettingsInvoice/Model.ts
// module id = 698
// module chunks = 0